
'use strict';

export default class DiscountRequestModal {
    constructor() {
        this.modal = document.querySelector('[data-discount-request-modal]');
        if (!this.modal) return;

        this.form = this.modal.querySelector("[data-discount-request-modal-form]");

        this.entryLists = this.modal.querySelectorAll("[data-discount-request-modal-entries]");

        this._init();
    }

    _init() {
        this._initListeners();

        this.entryLists.forEach(list => this._addEntry(list));
    }
    
    _initListeners() {
        this.entryLists.forEach((entryList) => {
            const addButton = entryList.querySelector("[data-discount-request-modal-entry-add]");
            addButton.addEventListener("click", this._onAddEntryClick.bind(this));
        });
    }

    _onAddEntryClick(e) {
        const button = e.currentTarget;
        const entryList = button.closest("[data-discount-request-modal-entries]");
        this._addEntry(entryList, button);
    }

    _addEntry(container, button) {
        const entryTmpl = container.querySelector("[data-discount-request-modal-entry-tmpl]");
        if (!entryTmpl) return;

        const entriesList = container.querySelector("[data-discount-request-modal-entries-list]");
        let newEntry = document.createElement("div");
        entriesList.appendChild(newEntry);
        newEntry.outerHTML = entryTmpl.innerHTML;

        window.initSelects();
        if (this.form.formHandlerObject) this.form.formHandlerObject.update();

        newEntry = entriesList.lastElementChild;
        const entryCounter = newEntry.querySelector("[data-discount-request-modal-entry-count]");
        entryCounter.innerText = entriesList.children.length;
        
        newEntry.querySelectorAll("input").forEach((input) => input.value = "");

        if (button) {
            $(".jquery-modal").animate({
                scrollTop: $(newEntry).position().top
            }, 500);
        }
    }
}